var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "TmFooter",
    {
      scopedSlots: _vm._u([
        {
          key: "logo",
          fn: function() {
            return [
              _c(
                "a",
                { attrs: { href: _vm.getDomain() } },
                [_c("TmLogo", { attrs: { claim: "cz" } })],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "TmRow",
        [
          _c(
            "TmCol",
            { attrs: { md: "4" } },
            [
              _c("TmFooterLinks", [
                _c("a", {
                  attrs: {
                    slot: "title",
                    href: _vm.getDomain() + "/podnikatele-firmy/sluzby",
                    target: "_blank"
                  },
                  domProps: { textContent: _vm._s(_vm.$t("footer.b2b.col1")) },
                  slot: "title"
                }),
                _vm._v(" "),
                _c("a", {
                  attrs: {
                    href: _vm.getDomain() + "/podnikatele-firmy/tarify",
                    target: "_blank"
                  },
                  domProps: {
                    textContent: _vm._s(_vm.$t("footer.b2b.col1-l1"))
                  }
                }),
                _vm._v(" "),
                _c("a", {
                  attrs: {
                    href:
                      _vm.getDomain() + "/podnikatele-firmy/tarify-velke-firmy",
                    target: "_blank"
                  },
                  domProps: {
                    textContent: _vm._s(_vm.$t("footer.b2b.col1-l2"))
                  }
                }),
                _vm._v(" "),
                _c("a", {
                  attrs: {
                    href: _vm.getDomain() + "/podnikatele-firmy/pevny-internet",
                    target: "_blank"
                  },
                  domProps: {
                    textContent: _vm._s(_vm.$t("footer.b2b.col1-l3"))
                  }
                }),
                _vm._v(" "),
                _c("a", {
                  attrs: {
                    href: _vm.getDomain() + "/podnikatele-firmy/eshop",
                    target: "_blank"
                  },
                  domProps: {
                    textContent: _vm._s(_vm.$t("footer.b2b.col1-l4"))
                  }
                })
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "TmCol",
            { attrs: { md: "4" } },
            [
              _c("TmFooterLinks", [
                _c("a", {
                  attrs: {
                    slot: "title",
                    href: _vm.getDomain() + "/podpora",
                    target: "_blank"
                  },
                  domProps: { textContent: _vm._s(_vm.$t("footer.b2b.col2")) },
                  slot: "title"
                }),
                _vm._v(" "),
                _c("a", {
                  attrs: {
                    href: _vm.getDomain() + "/podpora/vyuctovani-a-platby",
                    target: "_blank"
                  },
                  domProps: {
                    textContent: _vm._s(_vm.$t("footer.b2b.col2-l1"))
                  }
                }),
                _vm._v(" "),
                _c("a", {
                  attrs: {
                    href: _vm.getDomain() + "/podnikatele-firmy/roaming",
                    target: "_blank"
                  },
                  domProps: {
                    textContent: _vm._s(_vm.$t("footer.b2b.col2-l2"))
                  }
                }),
                _vm._v(" "),
                _c("a", {
                  attrs: {
                    href: _vm.getDomain() + "/katalog-sluzeb",
                    target: "_blank"
                  },
                  domProps: {
                    textContent: _vm._s(_vm.$t("footer.b2b.col2-l3"))
                  }
                }),
                _vm._v(" "),
                _c("a", {
                  attrs: {
                    href: _vm.getDomain() + "/podpora/caste-dotazy",
                    target: "_blank"
                  },
                  domProps: {
                    textContent: _vm._s(_vm.$t("footer.b2b.col2-l4"))
                  }
                }),
                _vm._v(" "),
                _c("a", {
                  attrs: {
                    href: _vm.getDomain() + "/ochrana-udaju",
                    target: "_blank"
                  },
                  domProps: {
                    textContent: _vm._s(_vm.$t("footer.b2b.col2-l5"))
                  }
                }),
                _vm._v(" "),
                _c("a", {
                  attrs: {
                    href:
                      "https://www.t-mobile.cz/ochrana-udaju/zpracovani-cookies",
                    target: "_blank"
                  },
                  domProps: {
                    textContent: _vm._s(_vm.$t("footer.b2b.col2-l6"))
                  }
                })
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "TmCol",
            { attrs: { md: "4" } },
            [
              _c("TmFooterLinks", [
                _c("a", {
                  attrs: {
                    slot: "title",
                    href: _vm.getDomain() + "/podpora/caste-dotazy",
                    target: "_blank"
                  },
                  domProps: { textContent: _vm._s(_vm.$t("footer.b2b.col3")) },
                  slot: "title"
                }),
                _vm._v(" "),
                _c("a", {
                  attrs: {
                    href: _vm.getDomain() + "/info/ke-stazeni",
                    target: "_blank"
                  },
                  domProps: {
                    textContent: _vm._s(_vm.$t("footer.b2b.col3-l1"))
                  }
                }),
                _vm._v(" "),
                _c("a", {
                  attrs: {
                    href:
                      _vm.getDomain() + "/podnikatele-firmy/navody-webinare",
                    target: "_blank"
                  },
                  domProps: {
                    textContent: _vm._s(_vm.$t("footer.b2b.col3-l2"))
                  }
                }),
                _vm._v(" "),
                _c("a", {
                  attrs: {
                    href: _vm.getDomain() + "/prodejny",
                    target: "_blank"
                  },
                  domProps: {
                    textContent: _vm._s(_vm.$t("footer.b2b.col3-l3"))
                  }
                }),
                _vm._v(" "),
                _c("a", {
                  attrs: {
                    href:
                      _vm.getDomain() +
                      "/podnikatele-firmy/kontaktni-informace",
                    target: "_blank"
                  },
                  domProps: {
                    textContent: _vm._s(_vm.$t("footer.b2b.col3-l4"))
                  }
                }),
                _vm._v(" "),
                _c("a", {
                  attrs: {
                    href:
                      _vm.getDomain() +
                      "/podnikatele-firmy/kontaktni-informace",
                    target: "_blank"
                  },
                  domProps: {
                    textContent: _vm._s(_vm.$t("footer.b2b.col3-l5"))
                  }
                })
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("template", { slot: "social" }, [
        _c(
          "a",
          {
            attrs: {
              href: "https://www.facebook.com/TMCZbusiness/",
              target: "_blank"
            }
          },
          [_c("TmIcon", { attrs: { type: "facebook", size: "sm" } })],
          1
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.instagram.com/tmobile_cze/",
              target: "_blank"
            }
          },
          [
            _c("TmIcon", {
              attrs: { type: "instagram", size: "sm", width: "23" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "http://www.youtube.com/user/tmobilecz",
              target: "_blank"
            }
          },
          [
            _c("TmIcon", {
              attrs: { type: "youtube", size: "sm", width: "25" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: { href: "https://twitter.com/TMobile_CZE", target: "_blank" }
          },
          [
            _c(
              "svg",
              { attrs: { viewBox: "0 0 25 25", width: "20", height: "20" } },
              [
                _c("path", {
                  attrs: {
                    fill: "currentColor",
                    d:
                      "M12.12,10.96l-3.3-4.62h-1.76l4.09,5.73,.51,.72h0l3.5,4.9h1.76l-4.29-6.01-.51-.72ZM23.62,1.38c-.92-.92-2.02-1.38-3.31-1.38H4.69C3.4,0,2.29,.46,1.38,1.38,.46,2.29,0,3.4,0,4.69v15.62c0,1.29,.46,2.4,1.38,3.31s2.02,1.38,3.31,1.38h15.62c1.29,0,2.4-.46,3.31-1.38s1.38-2.02,1.38-3.31V4.69c0-1.29-.46-2.4-1.38-3.31ZM14.63,18.51l-3.55-5.06-4.43,5.06h-1.15l5.08-5.78L5.5,5.49h3.87l3.35,4.78,4.2-4.78h1.15l-4.84,5.51,5.27,7.5h-3.87Z"
                  }
                })
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: "http://www.charger.cz/", target: "_blank" } },
          [
            _c("TmIcon", {
              attrs: { type: "charger", size: "sm", width: "25" }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("template", { slot: "copyright" }, [
        _vm._v(
          "© 2004-" +
            _vm._s(new Date().getFullYear()) +
            " T-Mobile Czech Republic a.s."
        )
      ]),
      _vm._v(" "),
      _c(
        "p",
        {
          attrs: { slot: "disclaimer" },
          domProps: { textContent: _vm._s(_vm.$t("footer.evidence")) },
          slot: "disclaimer"
        },
        [
          _vm._v(
            "\n    Podle zákona o evidenci tržeb je prodávající povinen vystavit kupujícímu účtenku. Zároveň je povinen zaevidovat přijatou tržbu u\n    správce daně on-line; v případě technického výpadku pak nejpozději do 48 hodin.\n  "
          )
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }